import React, { useMemo } from 'react';
import {
    AttributeDefinitionState,
    AttributeValueState,
    ComplementaryServiceTypeState,
} from '../../../../types/properties/propertyTypes';
import Label from '../Label';
import { Checkbox, FormControlLabel } from '@mui/material';
import { CheckCircle, CircleOutlined } from '@mui/icons-material';
import LoadingPlaceholder from '../../../../muiComponents/LoadingPlaceholder';
import IconButton from '../../../../muiComponents/IconButton';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import {
    full_ColumnGrid,
    gridSpacing20,
} from '../../../../utils/commonVariables/grid';
import {
    getGridChildSize,
    sortAttributeDefinitions,
} from '../../../../utils/property/propertyZinantisUtils';
import InputFieldFactory from './InputFieldFactory';
import useTranslate from '../../../../customHooks/useTranslate';

interface ServiceItemProps {
    service: ComplementaryServiceTypeState;
    attributeDefinitions?: AttributeDefinitionState[];
    attributeValues?: AttributeValueState[];
    selected: boolean;
    onToggle: () => void;
    isVisibleDetail: boolean;
    onToggleVisibleDetail: (idServiceType: number) => void;
    onChangeZitoneoServiceValue: (
        id: string,
        value: string | boolean | Date | number | null,
        idService: string,
        idAttributeDefinition: number
    ) => void;
    onRemoveZitoneoServiceValue: (
        id: string,
        idService: string,
        idAttributeDefinition: number
    ) => void;
    incompleteCount: number;
    requiredIncompleteCount: number;
}

const ServiceItem = (props: ServiceItemProps) => {
    const {
        service,
        selected,
        onToggle,
        attributeDefinitions,
        attributeValues,
        isVisibleDetail,
        onToggleVisibleDetail,
        onChangeZitoneoServiceValue,
        onRemoveZitoneoServiceValue,
        incompleteCount,
        requiredIncompleteCount,
    } = props;
    const translate = useTranslate();

    const sortedAttributeDefinitions = useMemo(() => {
        return attributeDefinitions
            ? sortAttributeDefinitions(attributeDefinitions)
            : [];
    }, [attributeDefinitions]);

    return (
        <div className='service-item'>
            <div
                className={`service-item__header ${
                    selected && isVisibleDetail && attributeDefinitions
                        ? 'border-color-bottom'
                        : ''
                }`}
            >
                <FormControlLabel
                    control={
                        <Checkbox
                            icon={
                                <CircleOutlined
                                    style={{ color: 'var(--border)' }}
                                />
                            }
                            checkedIcon={<CheckCircle />}
                            checked={selected}
                            name={service.name}
                            onChange={() => onToggle()}
                        />
                    }
                    disableTypography
                    label={<Label text={service.name} />}
                />

                {selected ? (
                    attributeDefinitions ? (
                        <div className='flex flex-align-center '>
                            <span
                                className={`font-size-12 ${
                                    requiredIncompleteCount
                                        ? 'zitoneo-label__required'
                                        : incompleteCount
                                        ? 'zitoneo-label__incomplete'
                                        : 'zitoneo-label__completed'
                                }`}
                            >
                                {requiredIncompleteCount > 0
                                    ? ` ${requiredIncompleteCount} ${translate(
                                          'missing_required'
                                      )}`
                                    : incompleteCount
                                    ? `${incompleteCount} ${translate(
                                          'incomplete'
                                      )}`
                                    : translate('complete')}
                            </span>

                            <IconButton
                                iconName={
                                    isVisibleDetail
                                        ? 'ExpandLess'
                                        : 'ExpandMore'
                                }
                                onClick={() => {
                                    onToggleVisibleDetail(parseInt(service.id));
                                }}
                            />
                        </div>
                    ) : (
                        <LoadingPlaceholder
                            variant='text'
                            width={100}
                            height={30}
                        />
                    )
                ) : null}
            </div>
            {isVisibleDetail && attributeDefinitions ? (
                <div className='service-item__content padding-block-20'>
                    <Grid
                        style={{ width: '100%' }}
                        columnSpacing={gridSpacing20}
                        rowSpacing={gridSpacing20}
                    >
                        {sortedAttributeDefinitions.map(attribute => {
                            const savedAttributeValues =
                                attributeValues?.filter(
                                    attrValue =>
                                        attrValue.idAttributeDefinition ===
                                        attribute.idAttributeDefinition
                                );

                            return (
                                <GridChild
                                    key={attribute.id}
                                    gridProps={
                                        attribute.unique
                                            ? getGridChildSize(
                                                  attribute.sizeKey
                                              )
                                            : full_ColumnGrid
                                    }
                                >
                                    <InputFieldFactory
                                        idService={service.id}
                                        values={savedAttributeValues || []}
                                        attributeDefinition={attribute}
                                        onChange={onChangeZitoneoServiceValue}
                                        onRemove={onRemoveZitoneoServiceValue}
                                    />
                                </GridChild>
                            );
                        })}
                    </Grid>
                </div>
            ) : null}
        </div>
    );
};

export default ServiceItem;
